import React, { useState, createContext, useContext } from 'react';
interface ScrollContextType {
  highlightAllText: () => void;
  setHighlightCallback: (callback: () => void) => void;
}
const ScrollContext = createContext<ScrollContextType>({
  highlightAllText: () => {},
  setHighlightCallback: () => {}
});
export const useScrollContext = () => useContext(ScrollContext);
export function ScrollProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Initialize with a proper function, not undefined
  const [highlightCallback, setHighlightCallback] = useState<() => void>(() => {
    // Return a function, not undefined
    return () => {
      console.log('Default highlight callback called');
    };
  });
  const highlightAllText = () => {
    console.log('Highlight all text called, executing callback');
    if (typeof highlightCallback === 'function') {
      highlightCallback();
    }
  };
  return <ScrollContext.Provider value={{
    highlightAllText,
    setHighlightCallback
  }} data-id="element-494" data-mp="6a783lsgnzqj">
      {children}
    </ScrollContext.Provider>;
}